export enum GoogleAdUrlType {
  PROPERTY_WEBSITE = 0,
  AGENT_WEBSITE = 1,
  OTHER = 2,
}
